import React from 'react';
import { APP_VERSION } from '../utils/version';

const Footer = () => {
  return (
    <>
      <div style={{
        backgroundColor: 'transparent',
        padding: '8px 16px 16px',
        width: '100%',
        textAlign: 'center',
        marginTop: 'auto',
        display: 'flex',
        justifyContent: 'center'
      }}>
        <div style={{
          maxWidth: '777px',
          width: '100%',
        }}>
          {/* Logo e nome completo app */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 18,
          }}>
            <img
              src="/logo192.png"
              style={{
                width: 40,
                height: 40,
                marginRight: 12,
                borderRadius: 8
              }}
              alt="123Scherma Logo"
            />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span style={{ fontWeight: 'bold', fontSize: 18 }}>
                123 Scherma!
              </span>
              <span style={{ fontSize: 12, color: '#757575', marginTop: 2 }}>
                v{APP_VERSION}
              </span>
            </div>
          </div>

          {/* Credits e copyright */}
          <div style={{ fontSize: 14, color: '#757575' }}>
            A.S.D. Scherma Verbania
          </div>
          <div style={{ fontSize: 12, color: '#757575' }}>
            Sviluppato da Giulio Rizzolio - {new Date().getFullYear()}
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
